import { type DataProvider } from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";
import { accessLevelsSchema } from "@/modules/accessLevels";
import { appleModelsSchema } from "@/modules/appleModels/api";
import { appVersionFlagsSchema } from "@/modules/appVersionFlags";
import { blacklistDevicesSchema } from "@/modules/blacklistDevices";
import { campaignsSchema } from "@/modules/campaigns";
import { campaignTdsSchema } from "@/modules/campaignTds/api";
import { citiesSchema } from "@/modules/cities";
import { clientAppsSchema } from "@/modules/clientApps";
import { countriesSchema } from "@/modules/countries";
import { countryPricesSchema } from "@/modules/countryPrice/api";
import { dataCentersSchema } from "@/modules/dataCenters";
import { deviceTypesSchema } from "@/modules/deviceTypes";
import { groupsSchema } from "@/modules/groups/api";
import { landingDomainsSchema } from "@/modules/landingDomains";
import { landingRegionsSchema } from "@/modules/landingRegions";
import { landingsSchema } from "@/modules/landings";
import { leadReportSchema } from "@/modules/leadReport";
import { mailSubjectsSchema } from "@/modules/mailSubjects";
import { osSchema } from "@/modules/os";
import { premiumIssuanceSchema } from "@/modules/premiumIssuance";
import { radiusVpnSchema } from "@/modules/radiusVpnServers";
import { rebillsSchema } from "@/modules/rebills";
import { receiptsSchema } from "@/modules/receipts";
import { resendPromoSchema } from "@/modules/resendPromo";
import { rolesSchema } from "@/modules/roles/api";
import { statisticsSchema } from "@/modules/statistics";
import { tariffsSchema } from "@/modules/tariffs";
import { ticketsSchema } from "@/modules/tickets";
import { trackersSchema } from "@/modules/trackers";
import { trafficSourcesSchema } from "@/modules/trafficSources";
import { usersSchema } from "@/modules/users";
import { createDataProvider } from "@/utils";

export const dataProvider: DataProvider = createDataProvider({
  [MODULE_NAMES.COUNTRIES]: countriesSchema,
  [MODULE_NAMES.CITIES]: citiesSchema,
  [MODULE_NAMES.ACCESS_LEVELS]: accessLevelsSchema,
  [MODULE_NAMES.TRAFFIC_SOURCES]: trafficSourcesSchema,
  [MODULE_NAMES.RECEIPTS]: receiptsSchema,
  [MODULE_NAMES.LEAD_REPORT]: leadReportSchema,
  [MODULE_NAMES.USERS]: usersSchema,
  [MODULE_NAMES.GROUPS]: groupsSchema,
  [MODULE_NAMES.TICKETS]: ticketsSchema,
  [MODULE_NAMES.TARIFFS]: tariffsSchema,
  [MODULE_NAMES.ROLES]: rolesSchema,
  [MODULE_NAMES.LANDINGS]: landingsSchema,
  [MODULE_NAMES.LANDING_DOMAINS]: landingDomainsSchema,
  [MODULE_NAMES.LANDING_REGIONS]: landingRegionsSchema,
  [MODULE_NAMES.APP_VERSION_FLAGS]: appVersionFlagsSchema,
  [MODULE_NAMES.MAIL_SUBJECTS]: mailSubjectsSchema,
  [MODULE_NAMES.CLIENT_APPS]: clientAppsSchema,
  [MODULE_NAMES.REBILLS]: rebillsSchema,
  [MODULE_NAMES.CAMPAIGNS]: campaignsSchema,
  [MODULE_NAMES.CAMPAIGN_TDS]: campaignTdsSchema,
  [MODULE_NAMES.DEVICE_TYPES]: deviceTypesSchema,
  [MODULE_NAMES.TRACKERS]: trackersSchema,
  [MODULE_NAMES.APPLE_MODELS]: appleModelsSchema,
  [MODULE_NAMES.OS]: osSchema,
  [MODULE_NAMES.STATISTICS]: statisticsSchema,
  [MODULE_NAMES.RADIUS_VPN_SERVERS]: radiusVpnSchema,
  [MODULE_NAMES.DATA_CENTERS]: dataCentersSchema,
  [MODULE_NAMES.BLACKLIST_DEVICES]: blacklistDevicesSchema,
  [MODULE_NAMES.PREMIUM_ISSUANCE]: premiumIssuanceSchema,
  [MODULE_NAMES.RESEND_PROMO]: resendPromoSchema,
  [MODULE_NAMES.COUNTRY_PRICES]: countryPricesSchema,
});
